// extracted by mini-css-extract-plugin
module.exports = {"container":"az_vUc","label":"az_wUc","productName":"az_xUc","link":"az_yUc"};